import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContentCourseFailureAttemptRateGauge from './ContentCourseFailureAttemptRateGauge';
import { ContentCourseFailureAttemptRateListService } from '../../services/ContentListService';
import ContentHistoryService from '../../services/ContentHistoryService';

class ContentCourseFailureAttemptRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    ContentCourseFailureAttemptRateListService.load();
  }
  render() {
    const data = ContentCourseFailureAttemptRateListService.getChart();
    return (
      <ContentCourseFailureAttemptRateGauge
        loading={
          ContentCourseFailureAttemptRateListService.fetchCurrent.fetching ||
          ContentCourseFailureAttemptRateListService.fetchPrevious.fetching
        }
        currentValue={toJS(data.current)}
        previousValue={toJS(data.previous)}
        formatter={ContentCourseFailureAttemptRateListService.getFormattedValue}
        onClickHistory={() => ContentHistoryService.openDialog('UNIT_ITEM_EXECUTION_FAILURE_ATTEMPT_RATE')}
      />
    );
  }
}

export default observer(ContentCourseFailureAttemptRateGaugeContainer);
